import React, { useEffect, useEffectEvent, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SectionName } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import CollapsibleList from '@divvy-web/skylab.collapsiblelist'
import { NavigationLink } from '@divvy-web/skylab.mainnavigation'

import ApplicationProgress from '@sputnik/pages/CreditApplicationPages/Navigation/ApplicationProgress'
import { useApplicationProgress } from '@sputnik/pages/CreditApplicationPages/Navigation/useApplicationProgress'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const BusinessInfoNavSection = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { tracker } = useWebTracking()

  const completionStatus = useApplicationProgress({ sectionName: SectionName.BUSINESS_INFO })

  const isPathNameAndOwnership = pathname.includes(PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH)
  const isPathnameBusinessAddress = pathname.includes(PATHNAME_CONSTS.BUSINESS_ADDRESS_PATH)
  const isBusinessInfoSectionActive = isPathNameAndOwnership || isPathnameBusinessAddress

  const [isMenuOpen, setIsMenuOpen] = useState(isBusinessInfoSectionActive)
  const onPathChange = useEffectEvent((isOpen: boolean) => {
    setIsMenuOpen(isOpen)
  })
  useEffect(() => {
    onPathChange(isPathNameAndOwnership || isPathnameBusinessAddress)
  }, [pathname, isPathNameAndOwnership, isPathnameBusinessAddress])

  return (
    <div onClickCapture={() => setIsMenuOpen((prev) => !prev)}>
      <CollapsibleList
        header={
          <NavigationLink
            icon={<ApplicationProgress status={completionStatus} />}
            label={
              <FormattedMessage
                defaultMessage='Business info'
                id='sputnik.BusinessInfoNavSection__EnfjLD'
              />
            }
          />
        }
        menuIsOpen={isMenuOpen}
      >
        <NavigationLink
          dataTestId='name-and-ownership-navigation-link'
          isActive={isPathNameAndOwnership}
          isExact={isPathNameAndOwnership}
          label={
            <FormattedMessage
              defaultMessage='Name and ownership'
              id='sputnik.BusinessInfoNavSection__RyW8Fx'
            />
          }
          onClick={() => {
            tracker?.track('se_signup__left_nav_menu_section_change__fired', {
              navigated_to_page: PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH,
            })
            navigate({ pathname: PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH }, { replace: true })
          }}
        />
        <NavigationLink
          dataTestId='business-address-navigation-link'
          isActive={isPathnameBusinessAddress}
          isExact={isPathnameBusinessAddress}
          label={
            <FormattedMessage
              defaultMessage='Business address'
              id='sputnik.BusinessInfoNavSection__RiFqwI'
            />
          }
          onClick={() => {
            tracker?.track('se_signup__left_nav_menu_section_change__fired', {
              navigated_to_page: PATHNAME_CONSTS.BUSINESS_ADDRESS_PATH,
            })
            navigate({ pathname: PATHNAME_CONSTS.BUSINESS_ADDRESS_PATH }, { replace: true })
          }}
        />
      </CollapsibleList>
    </div>
  )
}

export default BusinessInfoNavSection
